import { RefResourceType, RefServiceType } from "./Ref.dto";

export enum RefAuditAction {
  Create = "CREATE",
  Update = "UPDATE",
  Delete = "DELETE",
  Read = "READ",
}

export enum RefAuditCategory {
  // Auth
  Auth_User = "AUTH::USER",
  Auth_Organization = "AUTH::ORGANIZATION",
  Auth_Role = "AUTH::ROLE",
  Auth_Notification = "AUTH::NOTIFICATION",
  Auth_DictionaryLicense = "AUTH::DICTIONARY_LICENSE",

  // SSO
  SSO_AuthToken = "SSO::AUTH_TOKEN",
  SSO_RequestToken = "SSO::REQUEST_TOKEN",
  SSO_Notification = "SSO::NOTIFICATION",
  SSO_UserNotification = "SSO::USER_NOTIFICATION",
  SSO_UserDevice = "SSO::USER_DEVICE",

  // Billing
  Billing_Package = "BILLING::PACKAGE",
  Billing_Subscription = "BILLING::SUBSCRIPTION",
  Billing_Purchase = "BILLING::PURCHASE",
  Billing_NotificationMail = "BILLING::NOTIFICATION_MAIL",
  Billing_SubscriptionStatusNoti = "BILLING::SUBSCRIPTION_STATUS_NOTI",

  // Docs
  Docs_FolderFile_View = "DOCS::FOLDER_FILE_VIEW",
  Docs_FolderFile_Download = "DOCS::FOLDER_FILE_DOWNLOAD",
  Docs_Folder_Signer_Download = "DOCS::FOLDER_SIGNER_DOWNLOAD",

  // Builder
  Builder_StudyInfo = "BUILDER::STUDY_INFO",
  Builder_StudyDraftPayload = "BUILDER::STUDY_DRAFT_PAYLOAD",
  Builder_StudyPublishedPayload = "BUILDER::STUDY_PUBLISHED_PAYLOAD",
  Builder_StudyTemplateCrfVersion = "BUILDER::STUDY_TEMPLATE_CRF_VERSION",
  // Builder Property (Settings)
  Builder_StudyGeneralProperty = "BUILDER::STUDY_GENERAL_PROPERTY",
  Builder_StudySubjectColumnsProperty = "BUILDER::STUDY_SUBJECT_COLUMNS_PROPERTY",
  Builder_StudyEngineVersionProperty = "BUILDER::STUDY_ENGINE_VERSION_PROPERTY",
  Builder_StudyBlankCrfHeaderProperty = "BUILDER::STUDY_BLANK_CRF_HEADER_PROPERTY",
  Builder_StudyBlankCrfCoverProperty = "BUILDER::STUDY_BLANK_CRF_COVER_PROPERTY",
  Builder_StudyUatCoverProperty = "BUILDER::STUDY_UAT_COVER_PROPERTY",
  Builder_StudyEcoaConfigTwoFactorAuth = "BUILDER::STUDY_ECOA_CONFIG_TWO_FACTOR_AUTH",
  Builder_StudyEcoaConfigNotice = "BUILDER::STUDY_ECOA_CONFIG_NOTICE",
  Builder_StudyEcoaConfigNoticePerPage = "BUILDER::STUDY_ECOA_CONFIG_NOTICE_PER_PAGE",
  Builder_StudyEcoaConfigNoticeContent = "BUILDER::STUDY_ECOA_CONFIG_NOTICE_CONTENT",
  Builder_StudyEcoaConfigPopupTitle = "BUILDER::STUDY_ECOA_CONFIG_POPUP_TITLE",
  Builder_StudyEcoaConfigPopupContent = "BUILDER::STUDY_ECOA_CONFIG_POPUP_CONTENT",
  Builder_StudyEcoaConfigMisc = "BUILDER::STUDY_ECOA_CONFIG_POPUP_MISC",
  Builder_StudyEcoaConfigFontCTR = "BUILDER::STUDY_ECOA_CONFIG_FONT_CONTROLLER",
  Builder_StudyPayloadFolder = "BUILDER::STUDY_PAYLOAD_FOLDER",
  Builder_StudyPayloadPage = "BUILDER::STUDY_PAYLOAD_PAGE",
  Builder_StudyPayloadVisit = "BUILDER::STUDY_PAYLOAD_VISIT",
  Builder_StudyPayloadSection = "BUILDER::STUDY_PAYLOAD_SECTION",
  Builder_StudyPayloadPageSectionItem = "BUILDER::STUDY_PAYLOAD_PAGE_SECTION_ITEM",
  Builder_StudyPayloadScheduleMatrix = "BUILDER::STUDY_PAYLOAD_SCHEDULE_MATRIX",
  Builder_StudyPayloadDomain = "BUILDER::STUDY_PAYLOAD_DOMAIN",
  Builder_StudyRole = "BUILDER::STUDY_ROLE",
  Builder_StudyRolePrivilege = "BUILDER::STUDY_ROLE_PRIVILEGE",
  Builder_StudyMedicalCoding = "BUILDER::STUDY_MEDICAL_CODING",
  Builder_StudyMedicalCodingColumn = "BUILDER::STUDY_MEDICAL_CODING_COLUMN",
  /** @deprecated CDMS_StudySite 사용 요망 */
  Builder_StudySite = "BUILDER::STUDY_SITE",
  Builder_StudySiteEnvironment = "BUILDER::STUDY_SITE_ENVIRONMENT",
  Builder_StudyDashboardConfig = "BUILDER::STUDY_DASHBOARD_CONFIG",
  Builder_StudyDashboardConfigSubjectStatus = "BUILDER::STUDY_DASHBOARD_CONFIG_SUBJECT_STATUS",
  Builder_StudyDashboardConfigSite = "BUILDER::STUDY_DASHBOARD_CONFIG_SITE",
  Builder_StudyStatusCaptureStatus = "BUILDER::STUDY_STATUS_CAPTURE_STAT",
  Builder_StudyLabTestItem = "BUILDER::STUDY_LAB_TEST_ITEM",
  Builder_StudyLabTestItemUnit = "BUILDER::STUDY_LAB_TEST_ITEM_UNIT",
  Builder_StudyTemplate = "BUILDER::STUDY_TEMPLATE",
  Builder_StudyPayloadLabTestItem = "BUILDER::STUDY_PAYLOAD_LAB_TEST_ITEM",
  Builder_StudyPayloadLabTestUnit = "BUILDER::STUDY_PAYLOAD_LAB_TEST_UNIT",
  Builder_StudyPayloadTrigger = "BUILDER::STUDY_PAYLOAD_TRIGGER",
  Builder_StudyPayloadTriggerVersion = "BUILDER::STUDY_PAYLOAD_TRIGGER_VERSION",
  Builder_StudyPayloadValidation = "BUILDER::STUDY_PAYLOAD_VALIDATION",
  Builder_MemberOrganizationRole = "BUILDER::MEMBER_ORGANIZATION_ROLE",
  Builder_OrganizationRole = "BUILDER::ORGANIZATION_ROLE",
  Builder_OrganizationRolePrivilege = "BUILDER::ORGANIZATION_ROLE_PRIVILEGE",
  Builder_TriggerTargetMapping = "BUILDER::TRIGGER_TARGET_MAPPING",

  // Safety
  Safety_Cache = "SAFETY::CACHE",
  Safety_Workspace = "SAFETY::WORKSPACE",
  Safety_WorkspaceMember = "SAFETY::WORKSPACE_MEMBER",
  Safety_WorkspaceRole = "SAFETY::WORKSPACE_ROLE",
  Safety_Submission = "SAFETY::SUBMISSION",
  Safety_Preset = "SAFETY::PRESET",
  Safety_CaseCapture = "SAFETY::CASE_CAPTURE",
  Safety_CaseReportImportFile = "SAFETY::CASE_REPORT_IMPORT_FILE",

  // CDMS - legacy
  CrfData = "CRF:DATA",
  CrfQuery = "CRF:QUERY",
  CrfItemSdv = "CRF:ITEM:SDV",
  CrfItemFreezing = "CRF:ITEM:FREEZING",
  CrfItemLocking = "CRF:ITEM:LOCKING",
  CrfItemESign = "CRF:ITEM:ESIGN",
  CrfSdv = "CRF:SDV",
  CrfFreezing = "CRF:FREEZING",
  CrfEsign = "CRF:ESIGN",
  CrfSecondEsign = "CRF:SECOND_ESIGN",
  CrfLocking = "CRF:LOCKING",
  CdmsLabTest = "CDMS:LAB_TEST",
  CdmsLabNormalRange = "CDMS:LAB_NORMAL_RANGE",
  BuilderRtsmRandomization = "BUILDER:RTSM:RANDOMIZATION",
  BuilderRtsmIpm = "BUILDER:RTSM:IPM",
  PreSubjectReserved = "PRE_SUBJECT:RESERVED",

  // CDMS
  CDMS_StudySite = "CDMS::STUDY_SITE",
  CDMS_StudyIndependentEvaluation = "CDMS::STUDY_INDEPENDENT_EVALUATION",
  CDMS_StudySafetyIntegrationUser = "CDMS::STUDY_SAFETY_INTEGRATION_USER",
  CDMS_StudySubjectEnabled = "CDMS::STUDY_SUBJECT:ENABLED",
  CDMS_StudySafetyIntegrationHistory = "CDMS::STUDY_SAFETY_INTEGRATION_HISTORY",
  CDMS_StudyCategory = "CDMS::STUDY_CATEGORY",
  CDMS_StudyCategoryValue = "CDMS::STUDY_CATEGORY_VALUE",
  CDMS_StudySubjectGroup = "CDMS::STUDY_SUBJECT_GROUP",
  CDMS_StudyProtocolDeviation = "CDMS::STUDY_PROTOCOL_DEVIATION",
  CDMS_StudyProtocolDeviationConfig = "CDMS::STUDY_PROTOCOL_DEVIATION_CONFIG",
  CDMS_StudyProtocolDeviationCategory = "CDMS::STUDY_PROTOCOL_DEVIATION_CATEGORY",
  CDMS_StudyAttachmentFileUsage = "CDMS::STUDY_ATTACHMENT_FILE_USAGE",
  CDMS_StudyAttachmentFileUsageInfo = "CDMS::STUDY_ATTACHMENT_FILE_USAGE_INFO",
  CDMS_StudyLabTestStandardUnit = "CDMS::STUDY_LAB_TEST_STANDARD_UNIT",
  CDMS_StudyLabTestAlertNotification = "CDMS::STUDY_LAB_TEST_ALERT_NOTIFICATION",

  // Admin
  Admin_Notice = "ADMIN::NOTICE",
  Admin_Release = "ADMIN::RELEASE",

  // X
  X_ProjectTaskAttachmentEsign_Cancel = "X::PROJECT_TASK_ATTACHMENT_ESIGN:CANCEL",

  // RTSM
  RTSM_Study = "RTSM::STUDY",
  RTSM_StudyRole = "RTSM::STUDY_ROLE",
  RTSM_StudyUserRole = "RTSM::STUDY_USER_ROLE",
  RTSM_StudyRolePrivilege = "RTSM::STUDY_ROLE_PRIVILEGE",
  RTSM_StudyUser = "RTSM::STUDY_USER",
  RTSM_StudyUserRoleSite = "RTSM::STUDY_USER_ROLE_SITE",
  RTSM_StudyDepot = "RTSM::STUDY_DEPOT",
  RTSM_StudyDepotSite = "RTSM::STUDY_DEPOT_SITE",
  RTSM_StudySite = "RTSM::STUDY_SITE",
  RTSM_StudySubject = "RTSM::STUDY_SUBJECT",
  RTSM_StudySubjectCustomData = "RTSM::STUDY_SUBJECT_CUSTOM_DATA",
  RTSM_StudyVisitPath = "RTSM::STUDY_VISIT_PATH",
  RTSM_RandomStratification = "RTSM::RANDOM_STRATIFICATION",
  RTSM_RandomStratificationDetail = "RTSM::RANDOM_STRATIFICATION_DETAIL",
  RTSM_RandomGroup = "RTSM::RANDOM_GROUP",
  RTSM_RandomIsolation = "RTSM::RANDOM_ISOLATION",
  RTSM_RandomCodeUpload = "RTSM::RANDOM_CODE_UPLOAD",
  RTSM_RandomCode = "RTSM::RANDOM_CODE",
  RTSM_Randomization = "RTSM::RANDOMIZATION",
  RTSM_IpCategory = "RTSM::IP_CATEGORY",
  RTSM_IpDrug = "RTSM::IP_DRUG",
  RTSM_IpSchedule = "RTSM::IP_SCHEDULE",
  RTSM_IpCode = "RTSM::IP_CODE",
  RTSM_IpCodeChangeStatus = "RTSM::IP_CODE_CHANGE_STATUS",
  RTSM_IpCodeDispensedAt = "RTSM::IP_CODE_DISPENSED_AT",
  RTSM_IpCodeDispensedQuantity = "RTSM::IP_CODE_DISPENSED_QUANTITY",
  RTSM_IpCodeReturnedAt = "RTSM::IP_CODE_RETURNED_AT",
  RTSM_IpCodeReturnedQuantity = "RTSM::IP_CODE_RETURNED_QUANTITY",
  RTSM_IpCodeUnReturnedQuantity = "RTSM::IP_CODE_UN_RETURNED_QUANTITY",
  RTSM_IpCodeMetaData = "RTSM::IP_CODE_METADATA",
  RTSM_IpCodeUpload = "RTSM:IP_CODE_UPLOAD",
  RTSM_IpAutoDelivery = "RTSM:IP_AUTO_DELIVERY",
  RTSM_IpAutoDeliveryCondition = "RTSM:IP_AUTO_DELIVERY_CONDITION",
  RTSM_IpAutoDeliverySubCondition = "RTSM::IP_AUTO_DELIVERY_SUB_CONDITION",
  RTSM_IpAutoDeliverySubConditionDetail = "RTSM::IP_AUTO_DELIVERY_SUB_CONDITION_DETAIL",
  RTSM_IpAutoDeliveryRequest = "RTSM::IP_AUTO_DELIVERY_REQUEST",
  RTSM_IpAutoDeliveryRequestDetail = "RTSM::IP_AUTO_DELIVERY_REQUEST_DETAIL",
  RTSM_IpAutoDeliveryShippingPoint = "RTSM::IP_AUTO_DELIVERY_SHIPPING_POINT",
  RTSM_IpDelivery = "RTSM:IP_DELIVERY",
  RTSM_IpDeliveryDetail = "RTSM:IP_DELIVERY_DETAIL",
  RTSM_IpDeliveryIpCodeDetail = "RTSM::IP_DELIVERY_IP_CODE_DETAIL",
  RTSM_IpReturn = "RTSM::IP_RETURN",
  RTSM_IpReturnDetail = "RTSM::IP_RETURN_DETAIL",
  RTSM_StudyCustomComment = "RTSM::STUDY_CUSTOM_COMMENT",
  RTSM_StudyComment = "RTSM::STUDY_COMMENT",
  RTSM_StudyCustomQuery = "RTSM::STUDY_CUSTOM_QUERY",
  RTSM_StudyQuery = "RTSM::STUDY_QUERY",
  RTSM_NotificationEmail = "RTSM::NOTIFICATION_EMAIL",
  RTSM_IpAccountabilityBySite = "RTSM::IP_ACCOUNTABILITY_BY_SITE",
  RTSM_IpAccountabilityBySubject = "RTSM::IP_ACCOUNTABILITY_BY_SUBJECT",

  // Converter
  Converter_User = Auth_User,
  Converter_Study = "CONVERTER::STUDY",
  Converter_Import = "CONVERTER::IMPORT",
  Converter_Dataset = "CONVERTER::DATASET",
  Converter_DatasetVariable = "CONVERTER::DATASET_VARIABLE",
  Converter_ConversionFactor = "CONVERTER::CONVERSION_FACTOR",
  Converter_MyDictionary = "CONVERTER::MY_DICTIONARY",
  Converter_DefineXml = "CONVERTER::DEFINE_XML",
  Converter_Dataflow = "CONVERTER::DATA_FLOW",
  Converter_Crf = "CONVERTER::CRF",
  Converter_Validation = "CONVERTER::VALIDATION",
  Converter_MembersMember = "CONVERTER::MEMBERS_MEMBER",
  Converter_MembersRole = "CONVERTER::MEMBERS_ROLE",
  Converter_Report = "CONVERTER::REPORT",
  Converter_AdamDatasetVariable = "CONVERTER::ADAM_DATASET_VARIABLE",
}

export enum RefAuditReason {
  Create = "CREATE",
  Update = "UPDATE",
  Delete = "DELETE",
  Read = "READ",
}

export class RefAudit {
  id: bigint;
  refId: bigint;
  service: RefServiceType;
  type: RefResourceType;
  action: RefAuditAction;
  before: string;
  after: string;
  actantId: bigint;
  reasonKey: string;
  reason: string;
  category: RefAuditCategory;
  createdAt: Date;
  reserved1: string;
  reserved2: string;
  reserved3: string;
  reserved4: string;
}
